(() => {
  const KEY = "fh_collection_view";

  function setView(view) {
    document.documentElement.classList.toggle("fh-collection-list", view === "list");

    document.querySelectorAll(".fh-view-btn").forEach((btn) => {
      const active = btn.dataset.view === view;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    try { localStorage.setItem(KEY, view); } catch (e) {}
  }

  function init() {
    const saved = (() => {
      try { return localStorage.getItem(KEY); } catch (e) { return null; }
    })();

    setView(saved || "grid");
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".fh-view-btn");
    if (!btn) return;
    setView(btn.dataset.view);
  });

  // Re-init after Shopify filters/ajax refresh the grid
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);

  init();
})();
